import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import {
  DialogComponentI,
  ButtonComponent,
  DialogBodyComponent,
  DialogFooterComponent,
  DialogHeaderComponent,
  DialogRef,
} from '@core/user-interface-legacy';

type DialogData = { newRecoveryEmail: string };
type DialogResult = void;

@Component({
  selector: 'rt-password-recovery-email-dialog',
  template: `<rt-dialog-header
      [heading]="'tlc.current_user.verify_new_email.heading' | translate"
    />

    <rt-dialog-body variant="white" layout layout-vertical>
      <span
        [innerHTML]="
          'tlc.current_user.verify_new_email.description'
            | translate: { newEmail: this.newRecoveryEmail() }
        "
      >
      </span>
    </rt-dialog-body>

    <rt-dialog-footer variant="white">
      <rt-button (click)="close()" variant="primary">
        {{ 'tlc.common.got_it' | translate }}
      </rt-button>
    </rt-dialog-footer> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DialogHeaderComponent,
    DialogBodyComponent,
    DialogFooterComponent,
    ButtonComponent,
    TranslatePipe,
  ],
})
export class VerifyNewEmailDialogComponent implements DialogComponentI<DialogData, DialogResult> {
  private readonly dialogRef = inject(DialogRef);

  protected newRecoveryEmail = signal<string>('');

  public setDialogData(data: DialogData, triggerUpdate: boolean): void {
    this.newRecoveryEmail.set(data.newRecoveryEmail);
  }

  protected close(): void {
    this.dialogRef.close();
  }
}
